export type ThemeMode = 'light' | 'dark' | 'system'

export const THEME_STORAGE_KEY = 'hr_ast_theme'

export const THEME_MODES: ThemeMode[] = ['light', 'dark', 'system']

export function getStoredTheme(): ThemeMode {
  const raw = localStorage.getItem(THEME_STORAGE_KEY)
  if (raw === 'light' || raw === 'dark' || raw === 'system') {
    return raw
  }
  return 'system'
}

export function resolveIsDark(mode: ThemeMode): boolean {
  if (mode === 'dark') {
    return true
  }
  if (mode === 'light') {
    return false
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

/** Apply `dark` class on `<html>` for Tailwind dark mode. */
export function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement
  const isDark = resolveIsDark(mode)
  root.classList.toggle('dark', isDark)
  root.style.colorScheme = isDark ? 'dark' : 'light'
}

/** Run before Vue mounts to avoid flash of wrong theme. */
export function initThemeFromStorage(): void {
  applyTheme(getStoredTheme())
}
